import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {SharedModule} from '../../../../../core/modules/shared.module';
import {MaterialModule} from '../../../../../core/modules/material.module';

@Component({
  selector: 'qrcode-modal',
  templateUrl: './qrcode-modal.component.html',
  styleUrls: ['./qrcode-modal.component.scss'],
  standalone: true,
  imports: [SharedModule, MaterialModule],
})
export class QrcodeModalComponent {
  numberItem = 10;

  constructor(public dialogRef: MatDialogRef<QrcodeModalComponent>,
              @Inject(MAT_DIALOG_DATA) public data) {
  }

  downloadCode(): void {
    this.dialogRef.close(this.numberItem);
  }
}
